import { MailIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import toast from 'react-hot-toast';
import ajax from '../ajax';
import { useTranslations } from '../providers/i18n';

export default function ContactClinic({ clinic_id }) {
    const [t, translationsLoaded] = useTranslations('contact-clinic');
    const [open, setOpen] = useState(false);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    async function submit(e) {
        e.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            await ajax.post(`contact-clinic/${clinic_id}`, {
                subject,
                message,
            });
            cancel();
            toast.success('Pedido submetido com sucesso!');
        } catch {
            toast.error(e.response.data?.message || e.message);
        } finally {
            setLoading(false);
        }
    }

    function cancel() {
        setOpen(false);
        setSubject('');
        setMessage('');
    }

    if (!translationsLoaded) return null;

    return (
        <>
            {open ? (
                <div className="p-4 bg-white rounded-md shadow-md">
                    <form className="space-y-4" onSubmit={submit}>
                        <div className="flex justify-between pb-1 border-b border-gray-200">
                            <h2 className="text-xl font-medium text-blue-700">{t('title')}</h2>
                        </div>
                        <label className="block">
                            <div>{t('subject')}</div>
                            <input
                                type="text"
                                className="w-full border-2 border-gray-300 rounded-md focus:border-blue-600 focus:ring-0"
                                value={subject}
                                onChange={({ target: { value } }) => {
                                    setSubject(value);
                                }}
                                required
                            />
                        </label>
                        <label className="block">
                            <div>{t('message')}</div>
                            <textarea
                                type="text"
                                name="message"
                                rows="6"
                                className="w-full border-2 border-gray-300 rounded-md focus:border-blue-600 focus:ring-0"
                                value={message}
                                onChange={({ target: { value } }) => {
                                    setMessage(value);
                                }}
                                required
                            ></textarea>
                        </label>
                        <div className="space-x-4">
                            <button
                                className="inline-flex min-h-[2.5rem] items-center rounded-md border border-transparent bg-blue-700 px-4 py-2 text-sm font-medium text-gray-100 shadow hover:bg-blue-800 disabled:bg-blue-400"
                                disabled={loading}
                            >
                                {t('confirm')}
                            </button>
                            <button type="button" onClick={cancel} className="text-sm" disabled={loading}>
                                {t('cancel')}
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div className="flex justify-center">
                    <button
                        className="flex items-center justify-center gap-2 px-4 py-3 text-white bg-blue-700 rounded"
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <MailIcon className="h-5" />
                        <span>{t('opener')}</span>
                    </button>
                </div>
            )}
        </>
    );
}
